<template>
  <a :href="url" class="tab-guest">
    <guest-media
      :avatar-show="true"
      :summary-show="true"
      :full-name-show="true"
      :unit-show="true"
      :roombad-show="true"
      :b-day-show="bDayShow"
      :ass-soc-amm-sost-tutor-show="false"
      :guest-business-unit="guest"
    />
  </a>
</template>
<script>
import guestMedia from './guestMedia';
export default {
  name: 'guestTab',
  props: ['url', 'guest', 'bDayShow'],
  components: {
    guestMedia,
  },
  computed: {},
  mounted() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
.tab-guest {
  height: 50px;
  position: relative;
  .avatar {
    display: inline-block;
    margin-right: 10px;
    height: 50px;
    overflow: ellipsis;
    top: 7px;
    position: absolute;
    width: 50px;
    & img {
      height: 50px;
      width: 50px;
    }
  }
  .guest_info {
    margin-left: 60px;
    display: inline-block;
  }
}

a.tab-guest {
  border-radius: 5px 0 0 5px !important;
  & > a {
    padding: 6px 8px;
  }
  &.all_done {
    border-left: 5px solid #0b0;
  }
  &.none_done {
    border-left: 5px solid red;
  }
  &.some_done {
    border-left: 5px solid orange;
  }
}

.js-paperclip-document {
  cursor: pointer;
}

.tutor .box_msg {
  margin-right: 5px !important;
}

.tutor .box_msg,
.ammsost .box_msg {
  text-align: center;
}

.allergies .box_msg {
  margin-bottom: 10px;
  margin-right: 5px;
}

ul#tab-somministrations {
  margin-right: 5px;
}

.np_badge,
.fd_badge,
.somm > .done {
  cursor: pointer;
  margin: 2px auto;
}

.somm-heading > .done {
  margin: 0;
}

.somm > .done {
  text-align: center;
  & > .label {
    width: 1em;
  }

  & > input[type='checkbox'] {
    margin: 0 0 2px;
  }
}

.somm.np {
  min-height: 1em;
}

.somministrazioni {
  text-align: left;
  width: 100%;

  & > .somm_header {
    font-weight: bold;
  }

  & > .orario {
    margin-top: 1em;

    &:first-child {
      margin-top: 0;
    }
  }

  tr {
    th.orario_header {
      height: 3em;
      vertical-align: bottom;
    }
    &:first-child th.orario_header {
      border: 0;
      height: 1em;
    }
  }

  & th,
  & td {
    padding: 4px 5px !important; // .table-condensed
  }

  & th.flags,
  & td.flags {
    width: 80px;
  }
}

.somministrazione {
  list-style: none;
  border-bottom: 1px solid lightgray;

  &.success {
    background-color: #dff0d8;
  }

  & > .flags {
    & > .np {
      width: 100%;
    }
  }
}
</style>
